import React, { useContext } from 'react';
import styled from 'styled-components';
import { HELP_DESK_RESOLVED_COLORS } from '@ubeya/shared/constants/helpDesk';
import { ReactComponent as BaseResolvedCheckIcon } from '@ubeya/shared-web/assets/confirmation.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  background: ${HELP_DESK_RESOLVED_COLORS.background};
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
  padding-block: 0;
  padding-inline: 4px 8px;
`;

const ResolvedCheckIcon = styled(BaseResolvedCheckIcon)`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  fill: ${HELP_DESK_RESOLVED_COLORS.text};

  path {
    fill: ${HELP_DESK_RESOLVED_COLORS.text};
  }
`;

const Text = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${HELP_DESK_RESOLVED_COLORS.text};
`;

const ResolvedBadge = () => {
  const { t } = useContext(ConfigContext);

  return (
    <Badge>
      <ResolvedCheckIcon />
      <Text>{t('resolved')}</Text>
    </Badge>
  );
};

export default ResolvedBadge;
